import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-190c07f6"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "relative pt-14 pb-28 section"
};
var _hoisted_2 = { class: "container flex flex-col justify-center items-center lg:flex-row lg:justify-between" };
var _hoisted_3 = { class: "py-10 order-2 lg:order-1" };
var _hoisted_4 = ["textContent"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = { class: "flex items-center mt-5" };
var _hoisted_7 = { class: "ml-2" };
var _hoisted_8 = { key: 0 };
var _hoisted_9 = { class: "mt-2 text-3xl font-medium" };
var _hoisted_10 = {
    key: 0,
    class: "mr-2 text-opacity-60 line-through text-gray"
};
var _hoisted_11 = { key: 1 };
var _hoisted_12 = { key: 2 };
var _hoisted_13 = { class: "w-fit" };
var _hoisted_14 = {
    key: 2,
    class: "mt-2.5 text-center"
};
var _hoisted_15 = {
    key: 0,
    class: "text-gray-400"
};
var _hoisted_16 = {
    key: 1,
    class: "text-red-400"
};
var _hoisted_17 = {
    key: 2,
    class: "text-gray-400"
};
var _hoisted_18 = { class: "order-1 lg:order-2 relative justify-center items-center lg:ml-10 rounded-lg image lg:flex" };
var _hoisted_19 = ["src"];
import { CourseStore } from '@student/modules/store';
import { useLandingBlock } from '@student/components/Landing/Course/Blocks/useLandingBlock';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Order',
    props: {
        landingBlock: {}
    },
    emits: ["buyCourse"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var _b = useLandingBlock(function () { return props.landingBlock; }), courseLanding = _b.courseLanding, hasDiscount = _b.hasDiscount, landingCurrency = _b.landingCurrency, orderAction = _b.orderAction, parseTextWithUrl = _b.parseTextWithUrl;
        var limits = computed(function () {
            var group = CourseStore.course.group;
            var limitStudents = group.limitStudents || null;
            var studentsCount = group.studentsCount;
            var leftLimitStudents = limitStudents ? limitStudents - studentsCount : null;
            var hasLimit = limitStudents !== null;
            var lastChange = 6 > leftLimitStudents || (limitStudents / 100 * 20) > leftLimitStudents;
            return {
                hasLimit: hasLimit,
                leftLimitStudents: leftLimitStudents,
                lastChange: lastChange,
            };
        });
        //Плюрализм
        return function (_ctx, _cache) {
            var _a, _b;
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (!_unref(courseLanding).plansPayment)
                ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", {
                                class: "max-w-md text-3xl font-medium leading-relaxed md:text-5xl",
                                textContent: _toDisplayString(_ctx.landingBlock.title || _unref(t)('buttons.enrollCourse'))
                            }, null, 8, _hoisted_4),
                            (_ctx.landingBlock.subtitle)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "mt-3 max-w-lg text-lg description",
                                    innerHTML: _unref(parseTextWithUrl)(_ctx.landingBlock.subtitle)
                                }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_6, [
                                (_unref(hasDiscount))
                                    ? (_openBlock(), _createBlock(_component_e_icon, {
                                        key: 0,
                                        class: "text-primary w-5 h-5",
                                        icon: "discount"
                                    }))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_7, [
                                    _createTextVNode(_toDisplayString(_unref(t)('info.price')), 1),
                                    (_unref(hasDiscount))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('info.withDiscount')), 1))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(": ")
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                (_unref(courseLanding).priceOld > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(courseLanding).priceOld) + " " + _toDisplayString((_a = _unref(landingCurrency)) === null || _a === void 0 ? void 0 : _a.symbol), 1))
                                    : _createCommentVNode("", true),
                                (_unref(courseLanding).price > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(courseLanding).price) + " " + _toDisplayString((_b = _unref(landingCurrency)) === null || _b === void 0 ? void 0 : _b.symbol), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(courseLanding).plansPayment ? _unref(t)('info.freePlan') : _unref(t)('info.completelyFree')), 1))
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                (limits.value.hasLimit && limits.value.leftLimitStudents < 1)
                                    ? (_openBlock(), _createBlock(_component_e_button, {
                                        key: 0,
                                        class: "mt-6",
                                        size: "large",
                                        type: "white",
                                        disabled: ""
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createTextVNode(_toDisplayString(_unref(t)('buttons.noSeats')), 1)
                                        ]; }),
                                        _: 1
                                    }))
                                    : (_openBlock(), _createBlock(_component_e_button, {
                                        key: 1,
                                        class: "mt-6",
                                        size: "large",
                                        onClick: _unref(orderAction)
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createTextVNode(_toDisplayString(_unref(t)('buttons.enroll')), 1)
                                        ]; }),
                                        _: 1
                                    }, 8, ["onClick"])),
                                (limits.value.hasLimit)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        (limits.value.leftLimitStudents < 1)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)('info.groupFull')), 1))
                                            : (limits.value.lastChange)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_unref(t)('info.placeLeft', limits.value.leftLimitStudents)) + "! ", 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(t)('info.place', limits.value.leftLimitStudents)), 1))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            (_ctx.landingBlock.image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.landingBlock.image,
                                    alt: "",
                                    class: "object-cover relative w-full h-full rounded-lg"
                                }, null, 8, _hoisted_19))
                                : (_openBlock(), _createBlock(_component_e_icon, {
                                    key: 1,
                                    class: "w-14 text-gray-200",
                                    icon: "image-stack"
                                }))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
